var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconTailieu = function SvgIconTailieu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9245 16.0189C18.283 16.0189 18.3585 16.0189 19.6415 16.0189C22.5849 16.0189 25 13.6038 25 10.6604C25 7.71698 22.5849 5.30189 19.6415 5.30189C19.2641 5.30189 18.8868 5.30189 18.5849 5.37736C17.6038 2.81132 15.1132 1 12.1698 1C8.39623 1 5.30189 4.09434 5.30189 7.86792V7.9434C5.22642 7.9434 5.15094 7.9434 5 7.9434C2.81132 7.9434 1 9.75472 1 11.9434C1 14.1321 2.81132 15.9434 5 15.9434C6.58491 15.9434 6.96226 15.9434 8.69811 15.9434",
    stroke: "#05060B",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0754 24.3209V10.9624",
    stroke: "#2F8BFF",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7549 20.019L13.0756 24.7738L8.32092 20.019",
    stroke: "#2F8BFF",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconTailieu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ICON-TAILIEU.5b379e64.svg";
export { ForwardRef as ReactComponent };